var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container request-list" },
    [
      _c(
        "md-list",
        { staticClass: "list_no-background" },
        [
          _vm._l(_vm.list, function(request) {
            return [
              _c(
                "md-list-item",
                {
                  key: request.saleIndex,
                  on: {
                    click: function($event) {
                      return _vm.$emit(
                        _vm.commonEvents.saleSelectEvent,
                        request
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "request-list__name text_large" }, [
                    _c("div", [_vm._v(_vm._s(_vm.cookUpHeading(request)))]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(request.name))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class:
                          "request-list__request\n                         request-list__request--" +
                          request.state
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              request.state ||
                                _vm.i18n.sale_in_process_of_creation()
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "request-list__control text_medium" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.i18n.lbl_continue()) +
                          "\n          "
                      ),
                      _c("md-icon", {
                        attrs: {
                          "md-src": "/static/img/arrow_continue_icon.svg"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dba8eae4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dba8eae4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/saleCreation/SaleCreation.RequestList.vue
// module id = 8t1P
// module chunks = 1